import React from "react";
import { Link as RouterLink } from "react-router-dom";

import TabItem from "components/ui/TabItem";
import SettingDefaultLeftView from "views/setting/components/layouts/SettingDefaultLeftView";

const Link = RouterLink as any;

interface TabItemProps {
  label: string;
  isActive: boolean;
  isView: boolean;
  onClick: () => void;
}

interface SettingWrapperProps {
  title: string;
  tabs?: TabItemProps[];
  children: React.ReactNode;
  rootStore: any;
}

const SettingWrapper = ({ title, tabs, children, rootStore }: SettingWrapperProps): JSX.Element => {
  return (
    <div className="article_setting">
      {/*왼쪽 메뉴 */}
      <SettingDefaultLeftView rootStore={rootStore} />
      <div className="section_content">
        <h3>{title}</h3>

        {tabs && (
          <div className="box_tab">
            {tabs.map((tab, index) => (
              <TabItem key={index} label={tab.label} isView={tab.isView} isActive={tab.isActive} onClick={tab.onClick} />
            ))}
          </div>
        )}

        <div className="close">
          <Link to="/">
            <button type="button">
              <span className="btn_order_history_close">닫기</span>
            </button>
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
};

export default SettingWrapper;
